import FileHelper from "../../../helpers/FileHelper";
import { StyledImg, StyledScreensaver } from "./ScreensaverStyles";

function ScreensaverView({
  data,
  screensaverRef,
  fadeTime,
  currentScreensaver,
  previousScreensaver,
  currentScreensaverPath,
  previousScreensaverPath,
  onScreensaverClick,
}) {
  return (
    <StyledScreensaver
      ref={screensaverRef}
      disabled={data.disabled || (!currentScreensaver && !previousScreensaver)}
      $fadeTime={fadeTime}
      onClick={onScreensaverClick}
    >
      {previousScreensaver && previousScreensaverPath && (
        <StyledImg
          key={previousScreensaverPath}
          src={FileHelper.apiPath(previousScreensaverPath)}
          alt={previousScreensaver.name}
        />
      )}

      {currentScreensaver && currentScreensaverPath && (
        <StyledImg
          key={currentScreensaverPath}
          src={FileHelper.apiPath(currentScreensaverPath)}
          alt={currentScreensaver.name}
          $fadeTime={fadeTime}
        />
      )}
    </StyledScreensaver>
  );
}

export default ScreensaverView;
